module.exports = __webpack_public_path__ + "img/person-4.19096b3b.png";